module.exports = __webpack_public_path__ + "static/media/saadan_spiller_du_graphic.8f0a50a5.png";